













import Base from './Base.vue';

export default Base.extend({
	name: 'RozpracovaneZakazky',
	components: {
		BaseFilterSestav: Base,
	},
});
